export default __webpack_public_path__ + "static/media/example.7536d97a.pdf";